import React, { useState, useEffect } from 'react'
import { Drawer } from 'antd'
import SmartTable, { SmartTableDataTypes } from '../shared/SmartTable'
import { connect } from '../../reducers/Dispatchers'
import { getTranslate } from 'react-localize-redux'
import { getUser } from '../../reducers/UserReducer'
import { requestWithPromise } from '../../utils'
import { HttpMethods } from '../../utils/apiHelper'

const mapStateToProps = state => ({
  t: getTranslate(state.locale),
  getUser: getUser(state.getUser)
})

const ContactPersonSectors = props => {
  const [contactPersonsSector, setContactPersonsSector] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (props.sector !== null && props.getUser) {
      requestWithPromise(`/api/sectors/${props.sector.id}/contact-persons`, HttpMethods.GET, null, props.getUser)
        .then((jsonData) => {
          setContactPersonsSector(jsonData.data)
          setLoading(false)
        })
    } else {
      setLoading(true)
    }
  }, [props.sector, props.getUser])

  const COLUMNS = [
    {
      type: SmartTableDataTypes.STRING,
      name: props.t('lastname'),
      key: 'firstname'
    },
    {
      type: SmartTableDataTypes.STRING,
      name: props.t('firstname'),
      key: 'lastname'
    },
    {
      type: SmartTableDataTypes.STRING,
      name: props.t('Email'),
      key: 'email'
    },
    {
      type: SmartTableDataTypes.STRING,
      name: props.t('Phone number'),
      key: 'phone'
    }
  ]

  return (
    <Drawer
      title={props.sector !== null ? props.t('Contact persons of') + ' ' + props.sector.name : '?'}
      width='640px'
      onClose={props.onClose}
      visible={props.sector !== null}
    >
      <SmartTable
        columns={COLUMNS}
        data={contactPersonsSector}
        loading={loading}
        noDataText={props.t('Without person contact')}
      />
    </Drawer>
  )
}

export default connect(mapStateToProps)(ContactPersonSectors)
